import { IconProps } from '../icon';

export function FichierJPGIcon(props: IconProps) {
  return (
    <svg
      height="76"
      viewBox="0 0 58 76"
      width="58"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g transform="translate(-300.5 -102.5)">
        <path
          d="m320.3 104h36.7v73h-55v-54.549z"
          fill="#fff"
          opacity=".964"
          stroke="#969696"
          strokeMiterlimit="10"
          strokeWidth="3"
        />
        <path
          d="m308.5 119.5h39v31h-39z"
          fill="#fff"
          stroke="#969696"
          strokeMiterlimit="10"
          strokeWidth="3"
        />
        <path
          d="m320.5 105v17.5h-17.5"
          fill="#fff"
          stroke="#969696"
          strokeMiterlimit="10"
          strokeWidth="3"
        />
        <g fill="#969696">
          <path d="m311.5 146.5h19l-9-11z" />
          <circle cx="325" cy="129" r="4" />
          <path d="m335 128-7 13 5 6h13z" />
          <path d="m306 156h46v16h-46z" />
        </g>
        <text
          fill="#fff"
          fontFamily="MyriadPro-Regular, Myriad Pro"
          fontSize="9"
          transform="translate(306 159.38)"
        >
          <tspan x="16.034" y="7">
            JPG
          </tspan>
        </text>
      </g>
    </svg>
  );
}

export default FichierJPGIcon;
